module.exports = __webpack_public_path__ + "img/ITW_hoehe_Niederlande.9f3aaf21.svg";